import { isMobileSafari, isChrome, isAndroid } from 'react-device-detect';

export const detectBrowserFN = () => {
  if (isMobileSafari) return 'isSafariIos';
  if (isAndroid && isChrome) {
    return 'isChromeAndroid';
  }
  return '';
};
